import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { CreateUpdateContainer } from '../../../components';
import { useCustomSubmit } from './utils/customSubmit';
import { useGroomersFields } from './fields/groomersFields';
import { useSocketContext } from '../../../contexts/SocketContext';
import { EditingLocked } from '../../../components/EditingLocked/EditingLocked';
import { editingLocked } from '../../../utils/editingLocked';
import { useAuthContext } from '../../../contexts/AuthContext';

export const CreateUpdateGroomer = ({ purpose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { profileLock } = useSocketContext();
  const { ownerInfo, getUserProfiles } = useAuthContext();
  const { id } = useParams();

  const [form] = Form.useForm();
  const [country, setCountry] = useState('');

  const { customSubmit } = useCustomSubmit({
    baseUrl: 'groomers',
    purpose
  });

  const { groomersFields } = useGroomersFields({ form, country, setCountry });

  useEffect(() => {
    (async () => {
      await getUserProfiles();
    })();
  }, []);

  return (
    <>
      {editingLocked(profileLock, id) && (
        <EditingLocked
          t={t}
          resources={{
            button: 'veterinarian_groomer',
            text: 'profile'
          }}
          navigate={navigate}
        />
      )}
      <CreateUpdateContainer
        withPageHeaderCustom
        purpose={purpose}
        baseUrl="groomers"
        resource="groomers"
        fields={groomersFields}
        fieldsCardTitle={t('groomers.header_panel')}
        fieldsCardIcon="medicine"
        customSubmit={customSubmit}
        customId={ownerInfo?._id}
        disabled={editingLocked(profileLock, id)}
        form={form}
      />
    </>
  );
};

CreateUpdateGroomer.propTypes = {
  purpose: PropTypes.string.isRequired
};
